type Params = {
  serviceType: string;
  name: string;
  description: string;
  addressLocality: string;
  addressRegion: string;
  audienceDescription: string;
  aggregateRating: number;
  provider: Record<string, unknown>; // https://43081j.com/2019/02/typescript-avoid-using-any
};

export const createSchemaService = ({
  serviceType,
  name,
  description,
  addressLocality,
  addressRegion,
  audienceDescription,
  aggregateRating,
  provider,
}: Params) => (
  {
    '@context': 'https://schema.org/',
    '@type': 'Service',
    name,
    description,
    serviceType,
    aggregateRating,
    areaServed: {
      '@type': 'GeoShape',
      address: {
        '@type': 'PostalAddress',
        addressLocality: `${addressLocality}`,
        addressRegion: `${addressRegion}`,
        addressCountry: 'US',
      },
    },
    audience: {
      '@type': 'PeopleAudience',
      description: `${audienceDescription}`,
    },
    provider,
  }
);
